import { LoadingOutlined } from '@ant-design/icons';
import { Flex, Spin } from 'antd';
import cx from 'clsx';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { processConfirmationApi } from '../../api/auth-user-api';
import { getErrorString } from '../../utils';
import { getCookie, setCookie } from '../../utils/cookies-util';

const ResendCode = ({
  email = '',
  confirmation_sent_at,
  isLogin = false,
  confirmation_delay = 1,
  containerClassName = '',
  customDescription = '',
}) => {
  const [loading, setLoading] = useState(false);
  const resendTime = confirmation_sent_at
    ? new Date(confirmation_sent_at).getTime() + confirmation_delay * 60 * 24 * 60
    : getCookie(`resend-time`) || new Date().getTime();
  const currentTime = new Date().getTime();
  const timeRemaining = (parseInt(resendTime, 10) - currentTime) / (24 * 60);
  const [timeLeft, setTimeLeft] = useState(parseInt(timeRemaining));

  useEffect(() => {
    if (timeRemaining > 0) {
      setTimeLeft(parseInt(timeRemaining));
    }
  }, []);

  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const handleResendCode = async () => {
    if (timeLeft > 0) return;
    setLoading(true);
    try {
      const params = new URLSearchParams({
        email,
        verification_type: 'confirmation',
      });

      const paramsStr = params.toString();
      const res = await processConfirmationApi({}, '?' + paramsStr);
      if (res && res?.status) {
        toast.success('Code Sent to provided email address');
        setTimeLeft(res?.confirmation_delay * 60);
        setCookie('resend-time', new Date().getTime() + res?.confirmation_delay * 60 * 24 * 60);
      }
    } catch (error) {
      toast.error(getErrorString(error));
    } finally {
      setLoading(false);
    }
  };

  const customIcon = <LoadingOutlined style={{ fontSize: 18, color: 'var(--ant-color-primary)' }} spin />;

  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor((timeLeft % 3600) / 60);
  const seconds = timeLeft % 60;

  const formattedTime =
    hours > 0
      ? `(${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')})`
      : `(${minutes}:${String(seconds).padStart(2, '0')})`;

  return (
    <Flex wrap="wrap" justify="center" align="center" gap={8} className={cx(containerClassName, 'notify-box')}>
      <div style={{ textAlign: 'center' }}>
        {customDescription
          ? customDescription
          : isLogin
            ? "Your email isn't verified yet. We've sent a verification link — "
            : "I didn't recieve the confirmation email"}
        {isLogin && timeLeft > 0 && 'please try again after'}
      </div>
      {loading ? (
        <Spin indicator={customIcon} />
      ) : (
        <div
          onClick={() => handleResendCode()}
          className="h5-semibold"
          style={{ color: 'var(--ant-color-primary)', cursor: 'pointer' }}
        >
          {timeLeft > 0 ? formattedTime : 'Resend Email'}
        </div>
      )}
    </Flex>
  );
};

export default ResendCode;
